module.exports = __webpack_public_path__ + "img/sns_tripadvisor.6c6b504a.png";